import { Text } from '@/src/common/components/elements/Text/Text'
import { styled } from '@/src/stitches.config'

export const LineItemContainer = styled('div', {
    display: 'flex',
    fd: 'column',
    py: 20,
    columnGap: '8%',
    '@media (min-width:520px)': {
        fd: 'row',
    },
    '.dateFinal': {
        display: 'none',
    },
})

export const CardImageContainer = styled('div', {
    flex: '.75 1 0%',
    width: 'fit-content',
    maxWidth: 300,
    mb: 25,
    '@sm': {
        flex: '.5 1 0%',
        mb: 0,
    },
})

export const LineItemInfoContainer = styled('div', {
    display: 'flex',
    flex: '1 1 0%',
    fd: 'column',
})

export const LineItemInfoActionContainer = styled('div', {
    display: 'flex',
    flex: '1 1 0%',
    fd: 'column',
    justifyContent: 'center',
})

export const ProductNameText = styled(Text, {
    fontSize: '1.4rem',
    fontWeight: 'bold',
    color: '$darkest',
    variants: {
        capitalization: {
            none: {
                textTransform: 'none',
            },
        },
    },
})

export const LabelText = styled(Text, {
    fontSize: '1.15rem',
    color: '$dark',
    fontWeight: 'bold',
})

export const ValueText = styled(Text, {
    position: 'relative',
    fontSize: '1.15rem',
    color: '$dark',
})

export const TextContainer = styled('div', {
    mb: '8px',
    lh: '1.65rem',
    textTransform: 'capitalize',
    '& span:first-child': {
        mb: '5px',
    },
    '& span': {
        lh: '1.5rem',
    },
})
